import { deepClone } from '@/utils'
import { stopBubble } from '@/utils/commonUtil'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as NumberUtils from '@/utils/NumberUtils'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { getObjectByCache, getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import * as TrackingConstants from '@/class/cargo/model/parameters/TrackingConstants'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { advancedQuery, queryLastModifyBookingByDay } from '@/api/AirImport/aiBooking'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import {
  batchDeleteJob,
  sendJobSiRui,
  validateChargeLockStatus,
  batchManagerCommit, batchReturnSubmit, batchModifyChargeLockStatus, getJobByUuid, updateJobCustomJobType
} from '@/api/booking/job'
import {
  getTrackingListByLob,
  checkChargeStateVerify,
  saveJobInfo,
  batchPreCommit,
  batchCommit,
  statisticsJobs,
  getJobSopStates, batchCheckRemoveCharge, batchRemoveCharge, batchShutout, canBatchShutout, shutOut
} from '@/api/seaExport/seaExportJob'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { cache } from '@/utils/cacheManager'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { recordSelectedStatus } from '@/utils/agGrid'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { APPLICATION_DIMENSION_JOB_CHARGE, Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import { workflowActionBatch } from '@/api/workflow'
import { LOG_AI_AIR_BOOKING, OPERATE_RETURN_ACTION } from '@/class/cargo/model/parameters/SystemConstants'
import lodash from 'lodash'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { validateJobForDelete } from '@/api/booking/job'
import { getInstructions } from '@/api/sysManage/uiCustom'

export default {
  methods: {
    // 加载指令按钮
    async loadInstructionButtons() {
      const res = await getInstructions({
        module: UICustomConstants.AI_BOOKING_MODULE,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet: true
      })
      this.instructioinBtns = res.data
    },
    // 查询[简单查询/高级查询]
    toQuery(saveJobNos, removedJobNos) {
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.toBackQuery(saveJobNos, removedJobNos)
        return
      }
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      let data
      if (typeof keyword !== 'undefined') {
        data = [
          new AdvancedSearchOption(null, 'job.JOB_NO', keyword, 'LIKE').formatObj2Json()
        ]
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    toAdvancedQuery(data) {
      const filter = this.filterJson
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        filter.conditions = this.handleConditionsBeforeQuery(data)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(filter.conditions)
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      filter.appendQuery = this.appendQuery
      if (this.isBpmEnabled) {
        filter.requires = ['bpm']
      }
      this.loading = getLoading4Cxt(this)
      if (this.notRefresh) {
        console.log('请等上次查询完再执行查询操作')
        return
      }
      this.notRefresh = true
      advancedQuery(filter).then(res => {
        const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
        let results = res.data.list
        if (this.appendQuery) { // 追加查询数据去重
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
          this.total = results.length
        } else {
          this.pageNum = res.data.pageNum
          this.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
          this.pageCount = res.data.pages
        }
        this.rowData = SopUtil.resolveSopState(results)
        if (this.gridApi) {
          this.gridApi.clearFocusedCell()
        }
        selectedStatus.revert()
      }).finally(() => {
        this.notRefresh = false
        this.loading.close()
      })
    },
    // 在查询之前，对条件进行预处理
    handleConditionsBeforeQuery(data) {
      if (!this.useOrderCenterMode) {
        if (!((this.$store.getters.currentOfficeId === 1 && this.hqViewAllList) || this.hierarchyViewList)) {
          data.push(new AdvancedSearchOption(null, 'job.OP_OFFICE', this.$store.getters.currentOfficeId).formatObj2Json())
        }
      }
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        const jobStates = []
        for (const c of SystemConstants.JOB_STATES) {
          jobStates.push(c.code)
        }
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        data.push(option.formatObj2Json())
      }
      return data
    },
    // 返回查询
    toBackQuery(jobs, removedJobs) {
      setTimeout(() => {
        this.backHandleQueryData(jobs, removedJobs)
      })
    },
    backHandleQueryData(results, removedJobs) {
      let hasNew = false // 是否有新增数据
      for (const item of results) {
        const index = this.rowData.findIndex(p => p.uuid === item.uuid)
        if (index >= 0) {
          this.rowData[index] = item
        } else {
          this.rowData.push(item)
          hasNew = true
        }
      }
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        if (removedJobs.findIndex(p => p.uuid === this.rowData[i].uuid) >= 0) {
          this.rowData.splice(i, 1)
        }
      }
      if (hasNew || removedJobs.length > 0) {
        /* 记录勾选项 */
        const rows = this.gridApi.getSelectedRows()
        if (rows.length > 0) {
          const keys = Array.from(rows, p => p.uuid)
          setTimeout(() => {
            const masterSelectedSet = new Set()
            const nodes = this.gridApi.rowModel.rowsToDisplay
            for (const node of nodes) {
              if (!node.data) {
                continue
              }
              if (keys.includes(node.data.uuid)) {
                node.setSelected(true)
                if (node.data.masterFlag) {
                  masterSelectedSet.add(node.data.uuid)
                }
              } else {
                if (node.data.lclMasterUuid && masterSelectedSet.has(node.data.lclMasterUuid)) {
                  setTimeout(() => {
                    node.setSelected(false)
                  })
                }
              }
            }
          }, 100)
        }
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        for (const item of results) {
          const node = nodes.find(p => p.data && p.data.uuid === item.uuid)
          node.setData(item)
        }
        // this.gridApi.resetRowHeights()
      }
    },
    // 业务编号右边放大镜图标点击事件处理
    showBusinessInfo(e) {
      stopBubble(e)
      this.templateSelectorDialog.ctx = new AirImportJob(this.selectedRow)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedRow.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 查看
    async toLook(row) {
      const action = row && Number(cache.config.get('JobDirectEditingStatus')) === 1 && row.jobState === 0 && !JobUtils.isBlockJob(row) && (await SecurityUtil.canEdit(new AirImportJob(row))) ? 'edit' : 'look'
      this.$emit(action, row || this.selectedRow)
    },
    // 编辑
    toEdit() {
      this.$emit('edit', this.selectedRow)
    },
    // 复制
    toCopy() {
      const jobList = this.selectedRows
      if (!jobList || jobList.length <= 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      if (jobList.length > 1) {
        this.$message.warning(this.$t('Message.SelectOneJob'))
        return
      }
      this.$emit('copy', this.selectedRows[0])
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileType !== 'csv') {
        this.$message.warning(this.$t('queryJob.UploadedOnlyBeInFormat'))
      } else {
        return true
      }
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.code === '0') {
        this.onImportSucceeded(response.data)
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message) {
        this.$message.info(this.$t('Message.Page') + message + this.$t('queryJob.ThatSOk'), this.$t('Message.ImportSuccessful1'))
      }
    },
    onPayInfoImportClick(e) {
      if (!this.checkHierarchyMulitple()) {
        e.stopPropagation()
      }
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row || {})
    },
    // 删除
    async toDelete() {
      const rows = this.selectedRows
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataToDelete'))
        return
      }
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState > 0) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('Message.IsNotOperationStatus'))
          return
        }
      }
      const jobKeys = []
      for (const row of rows) {
        jobKeys.push(row.uuid)
      }
      this.loading = getLoading4Cxt(this)
      const res = await validateJobForDelete({ keys: jobKeys }).finally(() => {
        this.loading.close()
      })
      this.handlerDelete(res.data, jobKeys)
    },
    // 删除验证结果
    handlerDelete(delMap, jobKeys) {
      if (!delMap.canDelete) {
        if (delMap.hasDelete) {
          this.$message.warning(this.$t('CargoMsg.HasDeletedForDeleteJob'))
        }
        if (delMap.existsSlaveJob) {
          this.$message.warning(this.$t('CargoMsg.HasSlaveJobForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsCharge) {
          this.$message.warning(this.$t('CargoMsg.HasChargeForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsMergeJob) {
          this.$message.warning(this.$t('CargoMsg.HasMergeForDeleteJob', [delMap.jobNo]))
        }
        return
      }
      this.$confirm(this.$t('Message.SureDeleteThese') + jobKeys.length + this.$t('Message.OrdersOfBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        this.loading.close()
        try {
          const res = await batchDeleteJob({ jobKeys: jobKeys, location: this.location })
          await this.handlerDeleteResult(res)
        } finally {
          this.loading.close()
        }
      }).catch(() => { })
    },
    // 删除成功处理
    async handlerDeleteResult(res) {
      const result = res.data
      if (result > 0) {
        const rows = this.selectedRows
        for (const row of rows) {
          const index = this.rowData.findIndex(p => p.uuid === row.uuid)
          if (index >= 0) {
            this.rowData.splice(index, 1)
          }
          if (row.lclMasterUuid) {
            const masterJob = this.rowData.find(p => p.uuid === row.lclMasterUuid)
            if (masterJob) {
              await new AirImportJob(masterJob).loadJobRelated({ job: true })
            }
          }
        }
        this.$message.success(this.$t('Message.DeleteSuccessfully'))
      }
    },
    // 修改SOP状态
    editState() {
      if (this.selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAJob'))
        return
      }
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      let lob = null
      for (const item of this.selectedRows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (lob !== null && lob !== item.lob) {
          this.$message.warning(this.$t('Message.PleaseSelectTheSameTypeOfJob'))
          return
        }
        lob = item.lob
      }
      getTrackingListByLob(lob).then(res => {
        this.stateDialog.trackingList = res.data
      })
      this.stateDialog.rows = this.selectedRows
      this.stateDialog.visible = true
    },
    // 退回操作/撤回
    async backReturn(pre) {
      const job = this.selectedRow
      if (this.isCooperate(job.cooperateStatus)) {
        this.$message.warning('[' + job.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
        return
      }
      let txt = ''
      if (job.jobState === SystemConstants.COMMITED) {
        this.btnInfo.operateNameCode = SystemConstants.OPERATE_PRINT_RETURN.code
        txt = this.$t('Message.Withdraw')
      } else if (job.jobState === SystemConstants.PRE_COMMIT) {
        this.btnInfo.operateNameCode = SystemConstants.OPERATE_RETURN_ACTION.code
        txt = this.$t('Message.ReturnAction')
      } else {
        return
      }
      if (!await JobUtils.backCheckJobState([job.uuid], pre ? SystemConstants.OPERATE_RETURN_ACTION.code : SystemConstants.OPERATE_PRINT_RETURN.code)) {
        this.toQuery()
        this.selectedRow = await getJobByUuid(job.uuid).then(res => res.data)
        return
      }
      this.$confirm(this.$t('Message.IsConfirm') + txt + '？', this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.onConfirmedPrintReturn()
      }).catch()
    },
    async onConfirmedPrintReturn() {
      const job = this.selectedRow
      await new AirImportJob(job).loadJobRelated({ job: true })
      job.jobState = SystemConstants.OPERATING
      const submitChargeState = Number(this.context.config.get('CommitJobChangedChargeState')) === 1
      const loading = getLoading4Cxt(this)
      try {
        if (submitChargeState) {
          await new AirImportJob(job).getCharges()
          for (const item of job.charges) {
            if (item.chargeState === BillingConstants.CHARGE_STATE_SUBMIT.code) {
              item.chargeState = BillingConstants.CHARGE_STATE_NORMAL.code
            }
          }
          if (job.masterFlag) {
            await new AirImportJob(job).getLclSlaves()
            for (const lclJob of job.lclSlaves) {
              const charges = await new AirImportJob(lclJob).getCharges()
              for (const charge of charges) {
                if (charge.chargeState === BillingConstants.CHARGE_STATE_SUBMIT.code) {
                  charge.chargeState = BillingConstants.CHARGE_STATE_NORMAL.code
                }
              }
            }
          }
        }
        job.manageAuditStatus = 0
        job.operateNameCode = this.btnInfo.operateNameCode
        const res = await saveJobInfo(this.getBasicTypeObject(job))
        this.mergeCurrentRow(res)
        job.charges = ''
        await new AirImportJob(job).getLclSlaves()
        for (const item of job.lclSlaves) {
          item.charges = ''
        }
        job.isCompleteRow = false
        if (this.btnInfo.showMessage) {
          this.$message.info(this.$t('Message.AlreadyWithdraw'))
        } else {
          this.btnInfo.showMessage = true
        }
        // 撤回时，撤回CBMS业务
        if (this.btnInfo.operateNameCode === SystemConstants.OPERATE_PRINT_RETURN.code) {
          await sendJobSiRui({ jobUuid: job.uuid }).then(res => {
            const message = res.data
            if (message) {
              this.$message.info('思锐委托单推送失败,请联系工作人员排查:' + message)
            } else {
              this.$message.info(this.$t('CargoMsg.Cargo_PushSuccessByCBMS'))
            }
          })
        }
      } finally {
        loading.close()
      }
    },
    // 获取一个只有基本类型属性的对象副本
    getBasicTypeObject(job) {
      const result = { ...job }
      for (const key in result) {
        if (typeof result[key] === 'object') {
          delete result[key]
        }
      }
      return result
    },
    // 合并当前job【刷新当前job】
    mergeCurrentRow(res) {
      if (res && res.data) {
        for (const key in res.data) {
          if (typeof this.selectedRow[key] === 'object') {
            continue
          }
          this.selectedRow[key] = res.data[key]
        }
      }
    },
    // 批量预提交
    toBatchPreSubmit() {
      const jobKeys = []
      for (const j of this.selectedRows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (Number(j.jobState) !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('Message.BulkSubmissionOfWrittenPreSubmissionsOnlyList'))
          return
        }
        jobKeys.push(j.uuid)
      }
      // 检查应付费用是否全部审核
      checkChargeStateVerify(jobKeys).then(res => this.checkChargeStateVerifyResult(res))
    },
    // 检查应付费用是否全部审核
    async checkChargeStateVerifyResult(res) {
      const result = res.data
      if (this.checkApChargeVerify && result === 0) {
        this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
      const officeId = this.$store.getters.currentOfficeId
      const rows = this.selectedRows
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_PRE_COMMIT.code
        const opOffice = (rows && rows.length > 0) ? rows[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          if (this.allowPartialCheckPass) {
            const callBack = () => { this.batchPreCommitCall() }
            this.checkingManager(rows, checkNode, callBack, null, true)
          } else {
            const callBack = () => { this.batchPreCommitCall() }
            this.checkingManager(rows, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesPreSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
          }).catch(() => {
          })
        }
      }
    },
    // 批量预提交处理结果
    handlerPreCommitResult(res) {
      const list = res.data
      const len = !list ? 0 : list.length
      this.toQuery()
      this.$message.success(this.$t('Message.BatchSubmittedPreSuccessfully') + ': ' + len)
    },
    // 批量提交
    async toBatchSubmit() {
      let jobKeys = []
      let selectedJobs = []
      const allowBatchSubmitJobState = cache.config.get('AllowBatchSubmitJobState')
      const allowBatchSubmitJobStateArr = allowBatchSubmitJobState ? allowBatchSubmitJobState.split(',') : []
      const operateStr = SystemConstants.OPERATING.toString()
      const preCommitStr = SystemConstants.PRE_COMMIT.toString()
      const len = allowBatchSubmitJobStateArr.length
      const paramsBpm = []
      for (const item of this.selectedRows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (len > 1 && allowBatchSubmitJobStateArr.includes(operateStr) && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.OPERATING || Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchSubmitCheck'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(operateStr) && !(Number(item.jobState) === SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckOperate'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckPre'))
          return
        }
        jobKeys.push(item.uuid)
        selectedJobs.push(item)
        // 构建bpm请求参数
        const paramBpm = {
          documentConfigId: Job_CHARGE.code,
          docId: item.uuid,
          docNo: item.jobNo,
          actionType: 7000,
          officeId: item.opOffice,
          applicationDimension: APPLICATION_DIMENSION_JOB_CHARGE.code
        }
        paramsBpm.push(paramBpm)
      }
      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            selectedJobs = []
            for (const item of this.selectedRows) {
              if (jobKeys.indexOf(item.uuid) !== -1) {
                selectedJobs.push(item)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_COMMIT.code
        const opOffice = (selectedJobs && selectedJobs.length > 0) ? selectedJobs[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = selectedJobs // 回调中使用
          this.paramsBpm = paramsBpm
          this.opOffice = selectedJobs[0].opOffice
          if (this.allowPartialCheckPass) {
            const callBack = () => { this.batchCommitCall() }
            this.checkingManager(selectedJobs, checkNode, callBack, null, true)
          } else {
            const callBack = () => { this.batchCommitCall() }
            this.checkingManager(selectedJobs, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease12'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(async() => {
            if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: selectedJobs[0].opOffice })) {
              WorkflowUtil.jobBatchCommitBpm(this, paramsBpm)
              return
            }
            const officeId = this.$store.getters.currentOfficeId
            batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
          }).catch(() => { })
        }
      }
    },
    // 批量提交回调
    async batchCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        this.$logger.log('提交——jobKeys：', jobKeys)
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        // 过滤有效keys
        this.paramsBpm = this.paramsBpm.filter(paramBpm => jobKeys.indexOf(paramBpm.docId) !== -1)
        if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: this.opOffice })) {
          WorkflowUtil.jobBatchCommitBpm(this, this.paramsBpm)
          return
        }
        const officeId = this.$store.getters.currentOfficeId
        batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
      }
    },
    // 批量提交处理结果
    handlerCommitResult(res) {
      const list = res.data
      const len = !list ? 0 : list.length
      this.toQuery()
      this.$message.success(this.$t('Message.BatchSubmittedSuccessfully') + ': ' + len)
    },
    // 批量预提交回调
    batchPreCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
        this.$logger.log('预提交——jobKeys：', jobKeys)
      }
      if (jobKeys && jobKeys.length > 0) {
        const officeId = this.$store.getters.currentOfficeId
        batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
      }
    },
    //  验证规则配置公用
    checkingManager(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.visible = true
      }
    },
    // 批量打印
    onBatchPrint(command) {
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      const jobKeys = Array.from(this.selectedRows, p => p.uuid)
      if (jobKeys.length > 0) {
        this.templateSelectorDialog.ctx = new AirImportJob().fillDefaultValue().getData()
        this.templateSelectorDialog.category = 'AIJOBLIST'
        this.templateSelectorDialog.data = {
          'JOB_UUID': jobKeys,
          'printSource': DocumentConstants.BATCH_PRINT_AI.code
        }
        // 是否按照多个打印
        if (command === this.$t('queryJob.PrintByBusinessNumber')) {
          Object.assign(this.templateSelectorDialog.data, {
            'JOB_UUID': jobKeys[0],
            multiplePrint: true,
            multipleJobUuid: jobKeys
          })
        }
        this.templateSelectorDialog.visible = true
      }
    },
    // 统计
    async toStatistics() {
      this.statisticsDialog.containShutOutJob = false
      const loading = getLoading4Cxt(this)
      try {
        await this.handleStatistics(false)
        this.statisticsDialog.visible = true
      } finally {
        loading.close()
      }
    },
    async handleStatistics(isChangeContainShutOutJob = false) {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        throw new ErrorTip(this.$t('Message.PleaseSelectAJob'))
      }
      let rows = this.selectedRows.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1 || Number(p.dataType) === 2))
      if (rows.length === 0) {
        rows = this.rowData.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1 || Number(p.dataType) === 2))
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('Message.PleaseSelectAJob'))
      }
      let slavesCount = 0
      let masterCount = 0
      let chargeWeightActual = 0
      const customerSet = new Set()
      const designationAgentSet = new Set()
      const jobKeys = []
      // 列表勾选的数据是否都为”已退关“
      let allJobShutOut = true
      for (const job of rows) {
        if (!job.shutOut) {
          allJobShutOut = false
          break
        }
      }
      for (const job of rows) {
        if (job.lclMasterUuid) {
          continue
        }
        if (job.shutOut) {
          // 弹窗手动修改”是否包含退关“
          if (isChangeContainShutOutJob && !this.statisticsDialog.containShutOutJob) {
            continue
          } else if (!isChangeContainShutOutJob && !allJobShutOut) { // 第一次打开弹窗
            continue
          }
        }
        jobKeys.push(job.uuid)
        if (job.masterFlag) {
          masterCount += 1
        } else {
          slavesCount += 1
          chargeWeightActual += job.chargeWeight || 0
        }
        if (!job.masterFlag) {
          customerSet.add(job.customerId)
        }
        if (job.designationAgent !== 0) {
          designationAgentSet.add(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = String(slavesCount)
      this.statisticsDialog.txtMaster = String(masterCount)
      this.statisticsDialog.txtCount = String(slavesCount + masterCount)
      this.statisticsDialog.txtChargeWeightActual = NumberUtils.formatNumber(chargeWeightActual, 2)
      this.statisticsDialog.txtCustomerCount = String(customerSet.size)
      this.statisticsDialog.txtDesignationAgentNum = String(designationAgentSet.size)
      if (!isChangeContainShutOutJob && allJobShutOut) {
        this.statisticsDialog.containShutOutJob = true
      }
      await statisticsJobs({ jobKeys, lob: 'AI', containShutOutJob: this.statisticsDialog.containShutOutJob }).then(res => {
        const data = res.data
        this.statisticsDialog.txtQuantityContract = NumberUtils.formatNumber(data.quantityContract)
        this.statisticsDialog.txtWeightContract = NumberUtils.formatNumber(data.weightContract, 2)
        this.statisticsDialog.txtCubageContract = NumberUtils.formatNumber(data.cubageContract, 3)
      })
    },
    // 批量处理费用
    chargeHandle() {
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      switch (this.chargeCommand) {
        case this.$t('SeaExport.AddCharges'):
          this.toAddCharge()
          break
        case this.$t('SeaExport.EditCharges'):
          this.toEditCharge()
          break
        case this.$t('SeaExport.DeleteCharges'):
          this.toDeleteCharge()
          break
        case this.$t('SeaExport.ChargeImport'):
          this.toImportCharge()
          break
      }
    },
    // 新增费用
    async toAddCharge() {
      const selectedJobs = []
      for (const obj of this.selectedRows) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      // if (!await this.validateChargeLocked(selectedJobs)) return
      // this.addChargeDetailDialog.selectedJobs = selectedJobs
      // this.addChargeDetailDialog.visible = true
      this.chargeTypeDialog.type = this.role.addPayableChargeRole ? 2 : 1
      this.chargeTypeDialog.selectedJobs = selectedJobs
      this.chargeTypeDialog.visible = true
    },
    onChargeTypeDialogConfirm() {
      this.chargeTypeDialog.visible = false
      // 应收是否锁定
      const type = this.chargeTypeDialog.type
      const rows = this.chargeTypeDialog.selectedJobs
      if (!rows || rows.length === 0) return
      if (type === 0) {
        const chargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0 && p.payableChargeLockedStatus > 0)
        if (chargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ARAP_Locked'))
          return
        }
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      } else if (type === 1) {
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
      } else if (type === 2) {
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      }

      if (this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        if (type === 0 || type === 2) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AR'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && this.role.addPayableChargeRole) {
        if (type === 0 || type === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AP'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Cannot_Add_Charge'))
        return
      }

      if (!JobUtils.checkJobCustomerIdIfSame(this.arSettlementUnitOptional, type, rows, this)) {
        return
      }
      this.addChargeDetailDialog.selectedJobs = rows
      this.addChargeDetailDialog.type = type
      this.addChargeDetailDialog.selectedScheme = []
      this.addChargeDetailDialog.visible = true
    },
    // 编辑费用
    async toEditCharge() {
      const selectedJobs = []
      for (const obj of this.selectedRows) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessOrIsNotOperationalState'))
        return
      }
      if (!await this.validateChargeLocked(selectedJobs)) return
      this.editChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.editChargeDetailDialog.selectedJobs = selectedJobs
      this.editChargeDetailDialog.visible = true
    },
    // 删除费用 todo 待优化，两个接口可以合并成一个接口
    async toDeleteCharge() {
      const selectedJobs = []
      const jobKeys = []
      const jobs = this.selectedRows
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          jobKeys.push(obj.uuid)
          selectedJobs.push(obj)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      this.deleteChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.deleteChargeDetailDialog.selectedJobs = selectedJobs
      this.deleteChargeDetailDialog.visible = true
    },
    // 删除费用处理结果
    batchCheckRemoveChargeResult(res) {
      const canDeleteChargeKeys = res.data
      if (canDeleteChargeKeys && canDeleteChargeKeys.length > 0) {
        batchRemoveCharge(canDeleteChargeKeys, this.location).then(res => {
          if (res.data > 0) {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
          } else {
            this.$message.error(this.$t('AirImport.OperationFailed'))
          }
        })
      } else {
        this.$message.warning(this.$t('Message.NoCostToRemove'))
      }
    },
    // 批量导入费用
    async toImportCharge() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请勾选数据')
        return
      }
      const selectedJobs = []
      let operateType = -1
      for (const obj of this.selectedRows) {
        if (obj.jobState !== SystemConstants.OPERATING) {
          this.$message.warning(this.$t('Message.AllDataMustBeOperating'))
          return
        }
        if (operateType > -1 && obj.operateType !== operateType) {
          this.$message.warning(this.$t('queryJob.PleaseWithTheSameMode'))
          return
        }
        operateType = obj.operateType
        selectedJobs.push(obj)
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (selectedJobs.length > 500) {
        this.$message.info(this.$t('Message.TheNumberOfSelectedDataLimited') + 500)
        return
      }
      if (!await this.validateChargeLocked(selectedJobs)) return
      /* 将相同的委托单位、订舱代理、承运人、整拼类型、货物类型、起运港、目的港、目的港代理带入到费用方案窗口 */
      let isSameCustomer = true
      let isSameBookingAgent = true
      let isSameCarrierId = true
      let isSameOperateType = true
      let isSameCargoType = true
      let isSameLoadingPort = true
      let isSameDestinationPort = true
      let isSameDestinationAgent = true
      let isSameVesselLine = true
      operateType = selectedJobs[0].operateType
      const customerId = selectedJobs[0].customerId
      const bookingAgent = selectedJobs[0].bookingAgent
      const carrierId = selectedJobs[0].carrierId
      const cargoType = selectedJobs[0].cargoType
      const loadingPort = selectedJobs[0].loadingPortCode
      const destinationPort = selectedJobs[0].destinationPortCode
      const destinationAgent = selectedJobs[0].destinationAgent
      let vesselLine = ''
      const port = getObjectByCache(basicCacheKeys.basic_data_Airport, 'code', selectedJobs[0].destinationPortCode)
      if (port) {
        vesselLine = port.region
      }
      for (const airExportJob of selectedJobs) {
        if (customerId !== airExportJob.customerId) {
          isSameCustomer = false
        }
        if (bookingAgent !== airExportJob.bookingAgent) {
          isSameBookingAgent = false
        }
        if (carrierId !== airExportJob.carrierId) {
          isSameCarrierId = false
        }
        if (operateType !== airExportJob.operateType) {
          isSameOperateType = false
        }
        if (cargoType !== airExportJob.cargoType) {
          isSameCargoType = false
        }
        if (loadingPort !== airExportJob.loadingPortCode) {
          isSameLoadingPort = false
        }
        if (destinationPort !== airExportJob.destinationPortCode) {
          isSameDestinationPort = false
        }
        if (destinationAgent !== airExportJob.destinationAgent) {
          isSameDestinationAgent = false
        }
        const airPort = getObjectByCache(basicCacheKeys.basic_data_Airport, 'code', airExportJob.destinationPortCode)
        if (airPort && vesselLine !== airPort.region) {
          isSameVesselLine = false
        }
      }
      const sameCondition = {}
      if (isSameCustomer) {
        sameCondition['customerId'] = customerId
      }
      if (isSameBookingAgent) {
        sameCondition['bookingAgent'] = bookingAgent
      }
      if (isSameCarrierId) {
        sameCondition['carrierId'] = carrierId
      }
      if (isSameOperateType) {
        sameCondition['containerLoadType'] = operateType
      }
      if (isSameCargoType) {
        sameCondition['cargoType'] = cargoType
      }
      if (isSameLoadingPort) {
        sameCondition['loadingPort'] = loadingPort
      }
      if (isSameDestinationPort) {
        sameCondition['destinationPort'] = destinationPort
      }
      if (isSameDestinationAgent) {
        sameCondition['destinationAgent'] = destinationAgent
      }
      if (isSameVesselLine) {
        sameCondition['vesselLine'] = vesselLine
      }
      this.chargeSchemeBatchDialog.source = this.addChargeDetailDialog.visible ? 'addCharge' : 'jobList'
      this.chargeSchemeBatchDialog.chargeType = this.addChargeDetailDialog.visible ? this.chargeTypeDialog.type : null
      this.chargeSchemeBatchDialog.selectedJobs = selectedJobs
      this.chargeSchemeBatchDialog.job = this.selectedJob ? this.selectedJob : selectedJobs[0]
      this.chargeSchemeBatchDialog.needCheckRange = !(selectedJobs.length > 1) // 勾选了多票业务就不要用单个业务数据区间过滤费用方案
      this.chargeSchemeBatchDialog.isSea = false
      this.chargeSchemeBatchDialog.lob = 'AI'
      this.chargeSchemeBatchDialog.originalCondition = sameCondition
      this.chargeSchemeBatchDialog.visible = true
    },
    // 导出处理
    exportHandle() {
      switch (this.exportCommand) {
        case this.$t('SeaExport.ExportToExcel'):
          this.toExportToExcel()
          break
        case this.$t('SeaExport.ExportWithSOPToExcel'):
          this.toExportWithSOPToExcel()
          break
      }
    },
    // 导出Excel
    toExportToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      const newRows = deepClone(this.selectedRows)
      this.toExport(newRows, allDisplayedColumns)
    },
    toExport(rows, columns) {
      const fileName = 'AirImportBookingList'
      exportExcel(fileName, rows, columns)
    },
    // 导出Excel(含SOP明细)
    async toExportWithSOPToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // copy一个新的
      const newRows = deepClone(this.selectedRows)
      if (!newRows || newRows.length <= 0) return
      const jobKeys = Array.from(newRows, p => p.uuid)
      let jobSopStates = {}
      await getJobSopStates(jobKeys).then(res => {
        jobSopStates = res.data
      })
      // 查询海运出口的所有SOP节点
      const sopTemplateMap = await SopUtil.getSopTemplateMap(newRows)
      const headerNameMap = new Map()
      const sopColumns = []
      // 循环每条业务数据
      for (let i = 0; i < newRows.length; i++) {
        const reJob = newRows[i] // 当前行
        if (!sopTemplateMap.hasOwnProperty(reJob.trackingTemplateUuid)) {
          continue
        }
        const trackMap = sopTemplateMap[reJob.trackingTemplateUuid]
        const newSopState = (jobSopStates && Object.prototype.hasOwnProperty.call(jobSopStates, reJob.uuid)) ? jobSopStates[reJob.uuid] : ''
        const currentJobSopState = !newSopState ? reJob.sopState : newSopState // 当前行的SOP数据

        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          if (trackMap.hasOwnProperty(columnName)) {
            const track = trackMap[columnName]
            if (track && (Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_E.code) || Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_SUPPLEMENT.code))) {
              continue
            }
          }
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? this.$t('Message.NotStart') : oldColumnValue
          if (!headerNameMap.has(columnName)) {
            headerNameMap.set(columnName, columnValue)
            sopColumns.push({ headerName: columnName, field: columnName, columnType: 'SOP' })
          }
          newRows[i][columnName] = columnName + ' ' + columnValue
        }
      }
      // 获取所有列
      const allColumns = [...allDisplayedColumns, ...sopColumns]
      this.toExport(newRows, allColumns)
    },
    // 验证费用锁定状态
    async validateChargeLocked(jobs) {
      if (jobs && jobs.length > 0) {
        let pass = true
        const keys = []
        for (const item of jobs) {
          if (item.uuid) {
            keys.push(item.uuid)
          }
        }
        await validateChargeLockStatus(keys).then(res => {
          pass = res.data
        }).catch()
        if (!pass) {
          this.$message.warning(this.$t('SeaExport.ChargeLocked'))
          return false
        }
      }
      return true
    },
    // 查询最近几天的业务
    queryLastModifyBookingByDay() {
      const loading = getLoading4Cxt(this)
      this.filterJson = {}
      this.filterJson.pageNum = this.pageNum
      this.filterJson.pageSize = this.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.modifiedBy = this.$store.getters.userId
      queryLastModifyBookingByDay(this.filterJson).then(res => {
        this.rowData = SopUtil.resolveSopState(res.data.list)
        this.pageNum = res.data.pageNum
        this.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.pageCount = res.data.pages
        if (this.gridApi) {
          this.gridApi.clearFocusedCell()
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 批量操作
    batchHandle(val) {
      if (val !== 3) {
        if (this.hierarchyViewList) {
          if (val !== 5) {
            this.checkOwnerBranch(this.selectedRows)
          }
        }
      }
      switch (val) {
        case 1:
          this.toBatchPreSubmit()
          break
        case 2:
          this.toBatchSubmit()
          break
        case 3:
          this.toBatchManagerSubmission()
          break
        case 4: // 批量撤回预提交
          this.toBatchReturnPreSubmit()
          break
        case 5: // 批量退回提交
          this.toBatchReturnSubmit()
          break
        case 6:
          // 批量锁定应收费用
          this.toBatchModifyChargeLockingStatus(true)
          break
        case 7:
          // 批量锁定应付费用
          this.toBatchModifyChargeLockingStatus(false)
          break
        case 8:
          this.toBatchUpdateCustomType()
          break
        case 12:
          this.toBatchModifyChargeLockStatus(true)
          break
        case 13:
          this.toBatchModifyChargeLockStatus(false)
          break
        case 17:
          this.toBatchModifyBusiness()
          break
        case 18:
          this.toBatchUpdateSopTemplate()
          break
        case 19:
          this.toBatchCooperation()
          break
        case 20:
          JobUtils.toBatchFillGpExplain(this.selectedRows, this.gpExplain)
          break
        case 21:
          JobUtils.batchLockJobHandler(this, this.selectedRows, true, this.toQuery)
          break
        case 22:
          JobUtils.batchLockJobHandler(this, this.selectedRows, false, this.toQuery)
          break
        case 23:
          this.toShutOut()
          break
        case 24:
          JobUtils.batchReturnReview(this, this.selectedRows)
          break
      }
      if (typeof val === 'string') {
        if (val.startsWith('instruction,')) {
          const tenantInstructionUuid = val.split(',')[1]
          const item = this.instructioinBtns.find(item => item.tenantInstructionUuid === tenantInstructionUuid)
          if (item) {
            // 指令处理逻辑
          }
        }
      }
    },
    // 空进的退关 叫作废
    toShutOut() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.OPERATING)) {
          this.$message.info(this.$t('Message.IsNotOperationStatusCannotBeCancellation'))
          return
        }
        // 财务审核
        if (item.jobState === 2) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenSubmittedCannotBeShutOut'))
          return
        }
        // 退关
        if (item.shutOut) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenCancellation'))
          return
        }
        jobKeys.push(item.uuid)
      }
      this.cancellationJobKeys = jobKeys
      canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res))
    },
    // 验证退关
    canBatchShutoutResult(res) {
      const result = Number(res.data)
      if (result === 0) {
        this.$confirm(this.$t('Message.SureCancellationAndDeleteCharge'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(async() => {
          const loading = getLoading4Cxt(this)
          try {
            await this.shutoutHandler().then(res => this.batchShutoutResult())
          } finally {
            loading.close()
          }
        }).catch(() => { })
      } else if (result === 1) {
        this.$message.info(this.$t('AirImport.PleaseFormInvoiceEtcVoid'))
      } else if (result === 2) {
        this.$message.info(this.$t('AirImport.PleaseFromTheMasterVoid'))
      } else if (result === 3) {
        this.$message.info(this.$t('AirImport.PleaseFromThisMasterVoid'))
      }
    },
    // 退关公共
    async shutoutHandler() {
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      batchShutout({ jobKeys, hasCharge: false, location: this.location }).then(res => this.batchShutoutResult(res))
    },
    // 退关处理结果
    batchShutoutResult(res) {
      const list = res.data
      const len = list == null ? 0 : list.length
      this.$message.success(this.$t('Message.CancellationSuccessfully') + ': ' + len)

      if (len === 0) return
      const objJobKey = {}
      const jobKeys = this.cancellationJobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          seaJob.shutOut = true
          seaJob.jobState = SystemConstants.SHUT_OUT
        }
      }
      this.refreshAgGrid()
    },
    // 获取选中行 dataType 区分拆并单数据 业务数据，1 主票 2 小票 3 MBL 4 MBL2 5 HBL2
    readSelectedRows() {
      const allRows = this.selectedRows
      const rows = []
      for (const row of allRows) {
        if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          rows.push(row)
        }
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 批量撤回提交
    async toBatchReturnSubmit() {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.COMMITED)) {
          this.$message.warning(this.$t('SeaExport.BatchReturnSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_PRINT_RETURN.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Withdraw') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'AI', location: this.location }).then(res => {
            this.loading.close()
            if (res.data) this.toQuery()
            this.$message.success(this.$t('Message.AlreadyWithdraw'))
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量锁定应收/应付费用
    async toBatchModifyChargeLockingStatus(receivable) {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new AirImportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.LockingChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 1 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullylockingedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量撤回预提交
    async toBatchReturnPreSubmit() {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchReturnPreSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_RETURN_ACTION.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Return') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'AI', location: this.location }).then(res => {
            this.loading.close()
            if (res.data) this.toQuery()
            this.$message.success(this.$t('Message.AlreadyReturn'))
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量主管提交
    async toBatchManagerSubmission() {
      let rows = []
      let jobKeys = []
      for (const j of this.selectedRows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!this.allowPartialCheckPass) {
          if (Number(j.jobState) !== Number(SystemConstants.OPERATING) && Number(j.jobState) !== Number(SystemConstants.PRE_COMMIT)) {
            this.$message.warning(this.$t('SeaExport.BatchManagerSubmissionTips'))
            return
          }
          if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
            this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
            return
          }
        }
        jobKeys.push(j.uuid)
        rows.push(j)
      }

      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            rows = []
            for (const j of this.selectedRows) {
              if (jobKeys.indexOf(j.uuid) !== -1) {
                rows.push(j)
              }
            }
          } else {
            return
          }
        }
        const checkNode = CheckRuleConstants.NODE_MANAGER_COMMIT.code
        const opOffice = (rows && rows.length > 0) ? rows[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          const callBack = this.batchBatchManagerSubmissionCall || null
          this.checkingManager(rows, checkNode, callBack, null, this.allowPartialCheckPass)
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesManagerSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
          }).catch(() => {
          })
        }
      }
    },
    batchBatchManagerSubmissionCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
      }
    },
    // 批量主管提交处理结果
    handlerBatchManagerSubmissionResult(res) {
      const len = res.data ? res.data.length : 0
      this.$message.success(this.$t('SeaExport.BatchManagerSubmissionSuccessfully') + len)
      this.toQuery()
    },
    // 导出导入订单模板
    exportOrderHandle() {
      switch (this.exportOrderCommand) {
        case this.$t('SeaExport.Add'):
          this.toAdd()
          break
        case this.$t('SeaExport.import'):
          this.$refs.uploadOrder.submit()
          break
        case this.$t('CargoMsg.Cargo_DownImportTemplate'):
          this.downloadTemplate()
          break
      }
    },
    // Lts同步
    batchLtsSyncHandle(val) {
      const rows = this.selectedRows
      if (!rows || rows.length <= 0) return
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      this.$refs.ltsBatchSyncCharge.onShow({ rows: rows, anyBool: val })
      this.ltsWindow.visible = true
    },
    beforeOrderUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 上传成功
    uploadOrderSuccess(res, file, fileList) {
      if (res.ok) {
        const h = this.$createElement
        this.$msgbox({
          title: this.$t('common.tips.prompt'),
          message: h('p', null, [
            h('p', { style: 'fontSize: 20px;paddingBottom:5px' }, this.$t('CargoMsg.Cargo_ImportingData')),
            h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
          ]),
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'success'
        })
      } else {
        this.$confirm(res.message, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          canCloseModule: true,
          type: 'warning'
        })
      }
    },
    // 下载导出订单模板
    downloadTemplate() {
      // ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, 'AI')
      // CARGO-39209 各个业务类型批量导入模板中，各模板加入样例文件
      this.downloadImportTemplateDialog.visible = true
    },
    // 组装查询条件
    async getCustomSearchItems() {
      const defaultSearchFields = []
      let searchField = new AdvancedSearchField()
      if (this.useOrderCenterMode && this.orderCenterBranch) {
        // 协作分公司
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ' && p.code !== this.$store.getters.currentOffice.code).sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1) // 其他分公司
        offices.forEach(row => { row.code = row.officeId }) // ID
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作任务创建时间
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.itemName = 'cooperate.DATE_CREATED'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateCreatedDate'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 委托单位
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': '',
        'tagValue': 'cmpIdx',
        'useSales': true,
        'includeAllOffice': this.conditonDisplayAllBranchData
      }
      searchField.fieldType = 'FIELD_COMPANY'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())

      if (this.isBpmEnabled) {
        // CARGO-39771 BPM各审批流增加快捷入口（增加审批流水号）
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'approvalForm.DOCUMENT_PROCESS_NO'
        searchField.itemLabel = 'CargoMsg.Cargo_ApprovalSerialNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      for (const item of this.defaultSearchItems) {
        if (item.itemName === 'job.CUSTOMER_ID' && item.fieldType === 'FIELD_COMPANY') {
          continue
        }
        if (item.itemType === 'userSea' || item.itemType === 'user' || item.itemType === 'user2') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.officeId = ''
          }
          defaultSearchFields.push(newItem)
        } else if (item.itemType === 'company' || item.itemType === 'office' || item.itemType === 'department5') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.includeAllOffice = true
          }
          defaultSearchFields.push(newItem)
        }
      }
      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        const saleProductList = getFilterCacheList(this.TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
          return mapping.statusEnabled === true && mapping.airImportEnabled === true
        })
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        defaultSearchFields.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.hierarchyViewList) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchFields)
      }
      if (this.$store.state.uiCustom.enable) {
        UICustomUtil.handleSearchItems(UICustomConstants.AI_BOOKING_MODULE, this.defaultSearchItems, defaultSearchFields)
      }
      return defaultSearchFields
    },
    // 是否协作业务
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode) {
        return true
      }
      return false
    },
    async initColumnDefs() {
      // CARGO-31277 SOPSOP节点显示列增加
      const sopColumns = await SopUtil.getSopColumns('AI')
      this.columnDefs = [...this.columnDefs, ...sopColumns]
      await JobUtils.enrichTotalRevenueColumnDefs(this.columnDefs, this)
      if (this.isBpmEnabled) {
        this.columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
          field: 'documentProcessNo',
          colId: 'documentProcessNo',
          width: 200,
          hide: true,
          excelRenderer: (params) => {
            if (params.value) {
              return params.value
            }
            return ''
          },
          cellRenderer: (params) => {
            if (params.value) {
              const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
              return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.documentProcessNo ? params.data.documentProcessNo : ''
          }
        })
      }
      if (this.isZY) {
        this.columnDefs.push(
          {
            headerName: this.$t('CargoMsg.AllowSaleProduct'),
            field: 'saleProductCode',
            colId: 'saleProductCode',
            width: 200,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.FullOrInside'),
            field: 'fullOrInside',
            colId: 'fullOrInside',
            width: 200,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.fullOrInsideLabelFun(Number(params.value))
            }
          }
        )
      }
    },
    // 批量修改业务
    toBatchModifyBusiness() {
      const rows = this.selectedRows
      if (rows.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (rows.length > 200) {
        this.$message.warning(this.$t('SeaExport.maxSelectBusiness', ['200']))
        return
      }
      this.batchModifyBusinessDialog.lob = 'AI'
      this.batchModifyBusinessDialog.jobList = rows
      this.batchModifyBusinessDialog.jobKeys = Array.from(rows, p => p.uuid)
      this.batchModifyBusinessDialog.visible = true
    },
    // 批量修改业务成功后，弹窗回调
    batchModifyBusinessCallback() {
      this.toQuery()
    },
    // 批量更换SOP模板
    toBatchUpdateSopTemplate() {
      JobUtils.batchUpdateSopTemplate(this, this.selectedRows)
    },
    // 批量发起协作
    toBatchCooperation() {
      this.batchCooperationDialog.jobList = this.selectedRows
      this.batchCooperationDialog.visible = true
    },
    reload() {
      this.toQuery()
    },
    // 刷新表格
    refreshAgGrid() {
      this.gridApi.refreshCells({ force: true })
      this.gridApi.redrawRows()
    },
    // 批量修改自定义业务类型
    toBatchUpdateCustomType() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const jobList = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (j.jobState !== SystemConstants.STATE_OPERATING.code) {
          this.$message.warning(this.$t(j.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
          return
        }
        jobKeys.push(j.uuid)
        jobList.push(j)
      }
      this.customJobTypeDialog.jobKeys = jobKeys
      this.customJobTypeDialog.jobList = jobList
      this.customJobTypeDialog.visible = true
    },
    // 批量修改自定义业务类型点击确定
    customJobTypeClickHandler() {
      const jobs = this.customJobTypeDialog.jobList
      if (jobs != null && jobs.length > 0) {
        const obj = {}
        obj.jobUuids = this.customJobTypeDialog.jobKeys
        obj.customJobType = this.customJobTypeDialog.customJobType
        this.loading = getLoading()
        updateJobCustomJobType(obj).then(res => this.updateJobCustomJobTypeResult(res)).finally(() => {
          this.loading.close()
        })
      }
    },
    // 批量修改自定义业务类型 处理结果
    updateJobCustomJobTypeResult(res) {
      this.loading.close()
      if (res.data) {
        this.$message.success(this.$t('SeaExport.CustomJobTypeBatchModifySuccess') + res.data)
        for (const seaJob of this.customJobTypeDialog.jobList) {
          seaJob.customJobType = this.customJobTypeDialog.customJobType
        }
        this.refreshAgGrid()
      }
      this.customJobTypeDialog.visible = false
      this.customJobTypeDialog.customJobType = ''
      this.customJobTypeDialog.jobKeys = []
      this.customJobTypeDialog.jobList = []
    },
    // 批量解锁应收/应付费用
    async toBatchModifyChargeLockStatus(receivable) {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new AirImportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.UnlockChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 0, location: this.location }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullyUnlockedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    toChangeSchema() {
      // 先打开费用方案弹框，选择方案后再带入到新增费用弹框
      this.toImportCharge()
    },
    // 处理费用方案选择
    handleSelectedScheme(selectedScheme) {
      // 关闭费用方案弹框
      this.chargeSchemeBatchDialog.visible = false
      // 打开新增费用弹框，并带入选择的费用方案
      this.addChargeDetailDialog.selectedJobs = this.readSelectedRows()
      this.addChargeDetailDialog.chargeType = this.chargeTypeDialog.type
      this.addChargeDetailDialog.selectedScheme = selectedScheme
      this.addChargeDetailDialog.visible = true
    }

  }
}
